import React from "react";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import { ColumnNoc, ColumnResult, ColumnQualification, ColumnRank, ColumnExpander } from "components/common/TableColumns"
import Label from "components/general/Label"
import {
    RESULT_STATUS,
    getResultStatusAsInteger,
    isStartListStatus,
    isFinishedStatus
} from "helpers/status";
import { findArray } from 'helpers/utils'
import LoaderSubComponent from "components/general/LoaderSubComponent";

import Competitor from 'components/presentation/Competitor';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


function ColumnStartOrder({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'LabelStartOrder',
    accessor = 'startSortOrder'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartOrder',
        }
    )
}

function ColumnHeat({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'LabelHeat',
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Heat',
            accessor: (props) => {
                let value = findArray(props?.eventUnitEntries, { eue_code: ['GROUP'] }).eue_pos;
                return value
            }
        }
    )
}

function ColumnRun({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    number,
    label = `HeaderRun${number}`,
}) {
    return (
        {
            Header: <Label data={label} sport={'BMF'} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `Run ${number}`,
            Cell: (props) => {
                let row = props.cell.row.original
                let extendedResults = row?.extendedResults ? row?.extendedResults : ''
                let value = findArray(extendedResults, { er_pos: [`RUN${number}`] });
                if( number && value === '' && row?.resultType != 'IRM')
                    return <div className="fw-bold">{extendedResults[number-1]?.er_irm}</div>
                return value.er_rank ? <>{value?.er_value}&nbsp;({value?.er_rank})</> : value?.er_value
            }
        }
    )
}

function ColumnRunSM({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    number,
    label = `HeaderRun${number}`,
}) {
    return (
        {
            Header: <Label data={label} sport={'BMF'} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `Run ${number}`,
            Cell: (props) => {
                let row = props.cell.row.original
                let extendedResults = row?.extendedResults ? row?.extendedResults : ''
                let value = findArray(extendedResults, { er_pos: [`RUN${number}`] });
                if( number && value === '' && row?.resultType != 'IRM')
                    return <div className="fw-bold">{extendedResults[number-1]?.er_irm}</div>
                return value.er_value
            }
        }
    )
}

function ColumnRunFnl({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    number,
    label = `HeaderRun${number}`,
}) {
    return (
        {
            Header: <Label data={label} sport={'BMF'} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `Run ${number}`,
            Cell: (props) => {
                let row = props.cell.row.original
                let extendedResults = row?.extendedResults ? row?.extendedResults : ''
                let value = findArray(extendedResults, { er_pos: [`RUN${number}`] });
                if( number && value === '' && row?.resultType != 'IRM')
                    return <div className="fw-bold">{extendedResults[number-1]?.er_irm}</div>

                if (value?.er_value2 === 'Y' && findArray(props.cell.row.original.extendedResults, { er_pos: ['RUN2'] }))
                    return <div className="fw-bold">{value.er_value}</div>
                else if (findArray(props.cell.row.original.extendedResults, { er_pos: ['RUN2'] }))
                    return <div className="text-decoration-line-through">{value.er_value}</div>

                return value.er_value
            }
        }
    )
}

export function ColumnName({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = '-',
    hideNoc = false,
    noLink = false,
    showGuide = false
}) {


    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== '-') {
                    lbl = label
                } else {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'HeaderTeam'
                }

                return (
                    <Label data={lbl} />
                )
            },
            accessor: (props) => (props?.participant?.name?.toUpperCase()),
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            noLink: noLink,
            showGuide: showGuide,
            Cell: (props) => {
                const row = props.cell.row.original
                let data;
                let guide;
                let medicalClass;
                if (row?.athletes) {
                    data = row?.athletes?.find(x => x !== undefined)?.participant // revisar si es necesario o ya no se usa?
                } else {
                    data = row?.participant
                }
                if (row?.guide) {
                    guide = row?.guide
                }

                if (Array.isArray(row?.teamAthletes) && row?.teamAthletes.length === 1) {
                    medicalClass = row.disciplineClass;
                }

                let warning = findArray(row.extendedResults, { er_code: ['WARNING'] })

                return (
                    <div className="d-flex flex-row">
                        <Competitor
                            hidePicture={true}
                            hideNoc={hideNoc}
                            nolink={noLink}
                            {...data}
                            guide={guide}
                            showGuide={showGuide}
                            disciplineClass={medicalClass}
                        />
                        {warning
                            ? <>&nbsp;*</>
                            : <></>
                        }
                    </div>)
            }
        }
    )
}

function TableColumnsQual() {
    return (
        [
            ColumnRank({ disableSort: false }),
            ColumnHeat({ disableSort: false }),
            ColumnStartOrder({ disableSort: false }),
            ColumnNoc({ disableSort: false }),
            ColumnName({ disableSort: false }),
            ColumnRun({ disableSort: true, number: '1' }),
            ColumnRun({ disableSort: true, number: '2' }),
            ColumnResult({ disableSort: true, label: "HeaderAverageDesc", headerClassName: 'text-end w-10' }),
            ColumnQualification({ disableSort: true, className: 'text-end fw-bold' })
        ]
    )
}

function TableColumnsQualSM() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnStartOrder({ disableSort: true, label: 'HeaderSO' }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnRunSM({ disableSort: true, number: '1' }),
            ColumnRunSM({ disableSort: true, number: '2' }),
            ColumnResult({ disableSort: true, label: "HeaderAverageShort", headerClassName: 'text-end w-10' }),
            ColumnQualification({ disableSort: true, className: 'text-end fw-bold' })
        ]
    )
}

function TableColumnsFnl() {
    return (
        [
            ColumnRank({ disableSort: false }),
            ColumnStartOrder({ disableSort: false }),
            ColumnNoc({ disableSort: false }),
            ColumnName({ disableSort: false }),
            ColumnRunFnl({ disableSort: true, number: '1' }),
            ColumnRunFnl({ disableSort: true, number: '2' }),
            ColumnResult({ disableSort: true, label: "HeaderBest", headerClassName: 'text-end w-10' }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

function TableColumnsFnlSM() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnStartOrder({ disableSort: true, label: 'HeaderSO' }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnRunFnl({ disableSort: true, number: '1' }),
            ColumnRunFnl({ disableSort: true, number: '2' }),
            ColumnResult({ disableSort: true, label: "HeaderBest", headerClassName: 'text-end w-10' }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

const TableExpanded = React.memo((props) => {
    return <div className="bmf-esl">{props?.row?.extCompetitor}</div>
})

//LOADS QUALIFICATION SCORE TABLE
const BmfScoreBoardQual = ({ data }) => {
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    let columns = (breakPoint === "sm" || breakPoint === "xs") ? TableColumnsQualSM() : TableColumnsQual()
    let hiddenColumns = []

    let showQualMark = data?.results?.items?.some(item => item.qualificationMark);
    if (!showQualMark)
        hiddenColumns.push('QualMark')
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST)
        hiddenColumns.push('Rank')
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.OFFICIAL) {
        hiddenColumns.push('StartOrder')
        hiddenColumns.push('Heat')
    }
    let currentPlayer = data?.results?.currentCompetitorResult?.participant?.code
    
    return (
        <>
            {data?.results?.items
                ? (
                    <>
                        {getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.INTERMEDIATE
                            ?
                            <>
                                <div className='bmf-scoreboard-header bmf-header-box-live'>
                                    <div className='justify-content-start fw-bold'><Label data={'HeaderQualification'} /></div>
                                    <div className='justify-content-end fw-bold'><Label data={'LabelInProgress'} /></div>
                                </div>
                            </>
                            :
                            <>
                                <div className='bmf-scoreboard-header bmf-header-box'>
                                    <div className='justify-content-start fw-bold'><Label data={'HeaderQualification'} /></div>
                                    {isStartListStatus(resultStatus)
                                        ? <></>
                                        : getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL
                                            ? <div className='justify-content-end fw-bold'><Label data={'HeaderFinished'} /></div>
                                            : <div className='justify-content-end fw-bold'><Label data={'HeaderOfficial'} /></div>

                                    }
                                </div>
                            </>
                        }
                        < MirsTable
                            //Dato to show by row
                            data={data?.results?.items}
                            //Columnas a visualizar 
                            columns={columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            hiddenColumns={hiddenColumns}
                            initialSortBy={isStartListStatus(resultStatus)
                                ? [{ id: 'StartOrder', desc: false }]
                                : [{ id: 'Rank', desc: false }]}
                            id={`mirs-table-result-${rsc}`}
                            getRowProps={row => ({
                                className: currentPlayer?.includes(row?.original?.participant?.code) ? 'currentIndicator' : '',
                            })}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
}

//LOADS FINAL SCORE TABLE
const BmfScoreBoardFinal = ({ data }) => {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    let columns = (breakPoint === "sm" || breakPoint === "xs") ? TableColumnsFnlSM() : TableColumnsFnl()
    let hiddenColumns = []

    let showQualMark = data?.results?.items?.some(item => item.qualificationMark);
    let showEsl = data?.results?.items?.some(item => item.extCompetitor);

    if (!showQualMark)
        hiddenColumns.push('QualMark')
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST)
        hiddenColumns.push('Rank')
    if (isFinishedStatus(resultStatus)) {
        hiddenColumns.push('StartOrder')
        hiddenColumns.push('Heat')
    }
    if (mirs_competition === 'EG2023' || !showEsl)
        hiddenColumns.push('Expander')

    let currentPlayer = data?.results?.currentCompetitorResult?.participant?.code

    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} />
        }
        />
    ), [resultStatus]);

    return (
        <>
            {data?.results?.items
                ? (
                    <>
                        {getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE
                            ?
                            <>
                                <div className='bmf-scoreboard-header bmf-header-box-live'>
                                    <div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                    <div className='justify-content-end fw-bold'><Label data={'LabelInProgress'} /></div>
                                </div>
                            </>
                            :
                            <>
                                <div className='bmf-scoreboard-header bmf-header-box'>
                                    {isFinishedStatus(resultStatus)
                                        ? <>
                                            <div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                            {getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL
                                                ? <div className='justify-content-end fw-bold'><Label data={'HeaderFinished'} /></div>
                                                : <div className='justify-content-end fw-bold'><Label data={'HeaderOfficial'} /></div>
                                            }
                                        </>
                                        : <div className='justify-content-start fw-bold'><Label data={'HeaderStartList'} /></div>
                                    }
                                </div>
                            </>
                        }
                        < MirsTable
                            //Dato to show by row
                            data={data?.results?.items}
                            //Columnas a visualizar 
                            columns={columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            hiddenColumns={hiddenColumns}
                            renderRowSubComponent={renderRowSubComponent}
                            initialSortBy={isStartListStatus(resultStatus)
                                ? [{ id: 'StartOrder', desc: false }]
                                : [{ id: 'Rank', desc: false }]}
                            id={`mirs-table-result-${rsc}`}
                            getRowProps={row => ({
                                className: currentPlayer?.includes(row?.original?.participant?.code) ? 'currentIndicator' : '',
                            })}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
}

const BmfScoreboard = ({ data }) => {
    return data?.results?.eventUnitCode.includes('FNL') ? <BmfScoreBoardFinal data={data} /> : <BmfScoreBoardQual data={data} />
};

export default BmfScoreboard;

